/**
 * Shop by League Section JavaScript
 * Simple tab switching functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get all shop by league sections
  const sections = document.querySelectorAll('.shop-by-league-section');
  
  sections.forEach(section => {
    const tabs = section.querySelectorAll('.sbl-tab');
    const products = section.querySelectorAll('.sbl-product');
    const showMoreLinks = section.querySelectorAll('.sbl-show-more');
    
    // Add click event to each tab
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const collectionId = this.dataset.collection;
        
        // Remove active class from all tabs
        tabs.forEach(t => t.classList.remove('active'));
        
        // Add active class to clicked tab
        this.classList.add('active');
        
        // Hide all products and show more links
        products.forEach(product => {
          product.classList.remove('show');
        });
        showMoreLinks.forEach(link => {
          link.classList.remove('show');
        });
        
        // Show products with matching collection id (only visible ones initially)
        const matchingProducts = section.querySelectorAll(`[data-collection-id="${collectionId}"]:not(.sbl-product-hidden)`);
        matchingProducts.forEach(product => {
          product.classList.add('show');
        });
        
        // Show show more link for current collection
        const matchingShowMore = section.querySelector(`.sbl-show-more[data-collection-id="${collectionId}"]`);
        if (matchingShowMore) {
          matchingShowMore.classList.add('show');
        }
      });
    });
    
    // Add click event to show more buttons
    showMoreLinks.forEach(showMore => {
      const button = showMore.querySelector('.sbl-show-more-link');
      if (button) {
        // Get the show more limit from the button's data attribute or default to 8
        const showMoreLimit = parseInt(button.dataset.showMoreLimit) || 8;
        
        button.addEventListener('click', function() {
          const collectionId = this.dataset.collection;
          
          // Get all hidden products for this collection
          const hiddenProducts = section.querySelectorAll(`[data-collection-id="${collectionId}"].sbl-product-hidden`);
          
          // Show only the next batch of hidden products (up to showMoreLimit)
          const productsToShow = Array.from(hiddenProducts).slice(0, showMoreLimit);
          productsToShow.forEach(product => {
            product.classList.add('show');
            product.classList.remove('sbl-product-hidden');
          });
          
          // Check if there are still hidden products after showing this batch
          const remainingHiddenProducts = section.querySelectorAll(`[data-collection-id="${collectionId}"].sbl-product-hidden`);
          
          // Only hide the show more button
          if (remainingHiddenProducts.length === 0) {
            showMore.style.display = 'none';
          }
        });
      }
    });
    
    // Initialize first tab as active
    if (tabs.length > 0) {
      tabs[0].click();
    }
  });
});
